import { useState } from "react";
import { Badge, FormGroup, Input, Label, TabPane } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { handleEnvelope, handleInterview } from "../../../../../reduxToolkit/reducers/letterBoxSlice";
import { EmailContentProp } from "../../../../../types/Applications";
import { dynamicImage } from "../../../../../utils";
import SvgIcon from "../../../../../coreComponents/SvgIcon";
import { Image } from "../../../../../coreComponents/Image";

const EmailContent: React.FC<EmailContentProp> = ({ tableId, contentData }) => {

  const { faIcon } = useAppSelector((state) => state.letterBox);
  const [fill, setFill] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <>
      <TabPane tabId={tableId}>
        <div className="mail-body-wrapper">
          <ul>
            {contentData.map((data, i) => (
              <li className="inbox-data" key={i}>
                <div className="inbox-user">
                  <FormGroup check inline className="m-0">
                    <Input className={`checkbox-primary`} name="emailCheckbox" id={`emailCheckbox${i}`} type="checkbox" />
                    <Label check for={`emailCheckbox${i}`} />
                  </FormGroup>
                  <div onClick={() => setFill(!fill)}>
                    <SvgIcon className={`important-mail ${fill ? "active" : ""}`} iconId="fill-star" />
                  </div>
                  <div className="rounded-border">
                    {data.image && <Image src={dynamicImage(`${data.image}`)} alt="user" />}
                    {data.shortName && (
                      <div className={data.color === "success" ? "circle-success" : ""}>
                        <p className={`font-${data.color}`}>{data.shortName}</p>
                      </div>
                    )}
                  </div>
                  <p>{data.name}</p>
                </div>
                <div className="inbox-message">
                  <div className="email-data" onClick={() => dispatch(handleInterview(true))}>
                    <span>
                      {data.message}
                      <span>{data.subMessage}</span>
                    </span>
                    <div className="inbox-width d-flex gap-2">
                      {data.badge &&
                        data.badge.map((item, i) => (
                          <Badge color="" className={`m-0 badge-light-${item.color} font-${item.color === "light" ? "light-dark" : item.color}`} key={i}>
                            {item.title}
                          </Badge>
                        ))}
                    </div>
                  </div>
                  <div className="email-timing">
                    <span>{data.time}</span>
                  </div>
                  <div className="email-options">
                    <i className={`fa fa-envelope-${!faIcon ? "o envelope-1" : "open-o envelope-2"}`} onClick={() => dispatch(handleEnvelope(!faIcon))} />
                    <i className="fa fa-trash-o trash-3" />
                    <i className="fa fa-print" />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </TabPane>
    </>
  );
};
export default EmailContent;